import React, { useEffect, useState } from 'react';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';
import { ChevronDownIcon, LockClosedIcon } from '@heroicons/react/24/outline';
import axios from '../../axios';
import PermisosTable from './PermisosTable';

const PermisosCollapsible = (props) => {
    const { permisosSelected, setPermisosSelected } = props;
    const [allPermissions, setAllPermissions] = useState([]);
    const [permisosFiltrados, setPermisosFiltrados] = useState([]);

    useEffect(() => {
        axios.get(`api/get_all_permissions`).then((resp) => {
            setAllPermissions(resp.data);
            let tempPermissions = [];
             
            resp.data.map((item) => {
                var i = tempPermissions.findIndex((ele) => ele.module === item.module);
                if (i <= -1) {
                    tempPermissions.push({
                        module: item.module,
                        permisions: filtrarPermisos(item.module, resp.data)
                    });
                }
                else return null;
            });
            setPermisosFiltrados(tempPermissions);
        }).catch(e => console.error("Error ", e));
    }, []);

    const filtrarPermisos = (module, data) => {
        var items = data.filter((item) => item.module === module);
        return items;
    };

    return (
        <div className="space-y-2">
            {permisosFiltrados.map((modulo, index) => (
                <Disclosure key={index}>
                    {({ open }) => (
                        <div className="rounded-lg border border-gray-200 bg-white overflow-hidden">
                            {/* Header del acordeón */}
                            <DisclosureButton className="flex w-full items-center justify-between px-4 py-3 text-left hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-blue-500 transition-colors">
                                <div className="flex items-center gap-2">
                                    <LockClosedIcon className="w-5 h-5 text-gray-500" />
                                    <span className="font-medium text-gray-900">{modulo.module}</span>
                                </div>
                                <ChevronDownIcon
                                    className={`h-5 w-5 text-gray-500 transition-transform duration-200 ${
                                        open ? 'rotate-180' : ''
                                    }`}
                                />
                            </DisclosureButton>

                            {/* Contenido con animación */}
                            <Transition
                                enter="transition duration-100 ease-out"
                                enterFrom="transform scale-95 opacity-0"
                                enterTo="transform scale-100 opacity-100"
                                leave="transition duration-75 ease-out"
                                leaveFrom="transform scale-100 opacity-100"
                                leaveTo="transform scale-95 opacity-0"
                            >
                                <DisclosurePanel className="border-t border-gray-200 bg-gray-50">
                                    <div className="p-4">
                                        <PermisosTable
                                            permisos={modulo.permisions}
                                            permisosSelected={permisosSelected}
                                            setPermisosSelected={setPermisosSelected}
                                        />
                                    </div>
                                </DisclosurePanel>
                            </Transition>
                        </div>
                    )}
                </Disclosure>
            ))}
        </div>
    );
};

export default PermisosCollapsible;